module.exports = __webpack_public_path__ + "static/media/weather-draw.a1d011a0.svg";